import { configureStore } from '@reduxjs/toolkit';

import portfolioReducer from './portfolioSlice';

/**
 * One store per mount. The shell can unmount and remount the Console, and a
 * module-level singleton would carry the previous session's state across that.
 *
 * What is left here is the Unit Registry prototype's in-browser book (Unit
 * Prices, the Bank Statement tab, the register, reports), until each of those
 * screens moves to the Console API as File Uploads, User Management and
 * Transaction Approval's orders (IP-89) have.
 */
export const createConsoleStore = () =>
    configureStore({
        reducer: {
            portfolio: portfolioReducer
        }
    });
